import { Directive, ElementRef, Input, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';

@Directive({
  selector: '[queDisplayByType]',
  standalone: true
})
export class DisplayByTypeDirective {
  @Input()
  typeId?: number;
  @Input()
  name: string = "";
  @Input()
  isCollection?: boolean;
  @Input()
  optionList?: OptionsList;
  isDisplay = false;
  all = [EQuestionType.Multi, EQuestionType.Autocomplete, EQuestionType.Mark, EQuestionType.FreeText,
  EQuestionType.Number, EQuestionType.Table, EQuestionType.PhoneNumber, EQuestionType.Range, EQuestionType.Title,
  EQuestionType.Text, EQuestionType.Link, EQuestionType.UploadFile,
  EQuestionType.Fill, EQuestionType.Divider, EQuestionType.Date, EQuestionType.QuestionsGroup, EQuestionType.Signature
    , EQuestionType.Image,
  EQuestionType.UploadFileAdmin, EQuestionType.Expense
  ]
  dictionary = [
    { name: "line", types: [...this.all.filter(t => t != EQuestionType.Title && t != EQuestionType.Signature)] },
    { name: "menu", types: [...this.all.filter(t => t != EQuestionType.Divider && t != EQuestionType.Title && t != EQuestionType.Text && t != EQuestionType.Signature && t != EQuestionType.Image && t != EQuestionType.UploadFile && t != EQuestionType.UploadFileAdmin && t != EQuestionType.Link)] },
    { name: "toggle", types: [...this.all.filter(t => t != EQuestionType.Divider && t != EQuestionType.Title && t != EQuestionType.Text && t != EQuestionType.Signature && t != EQuestionType.Image && t != EQuestionType.Link && t != EQuestionType.UploadFileAdmin)] },
    { name: "form", types: [...this.all.filter(t => t != EQuestionType.Divider && t != EQuestionType.Title)] },
    { name: "texts", types: [...this.all.filter(t => t != EQuestionType.Divider && t != EQuestionType.Title)] },
    { name: "textInTexts", types: [...this.all.filter(t => t != EQuestionType.QuestionsGroup && t != EQuestionType.Image && t != EQuestionType.Link && t != EQuestionType.Date)] },
    { name: "textInTextsDisplay", types: [...this.all.filter(t => t != EQuestionType.QuestionsGroup && t != EQuestionType.Image && t != EQuestionType.Link && t != EQuestionType.Date)] },
    { name: "saveList", types: [EQuestionType.Autocomplete, EQuestionType.Mark, EQuestionType.Multi] },
    { name: "inputTitle", types: [...this.all.filter(t => t != EQuestionType.Image)] },
    { name: "inputTitleToImage", types: [EQuestionType.Image] },
    { name: "title", types: [EQuestionType.Title] },
    // { name: "emptyMenu", types: [EQuestionType.QuestionsGroup] },
    { name: "addCollection", types: [...this.all.filter(t => t != EQuestionType.Divider)] },
    { name: "filterField", types: [...this.all.filter(t => t == EQuestionType.Autocomplete || t == EQuestionType.Date || t == EQuestionType.Mark || t == EQuestionType.Multi || t == EQuestionType.Fill)] },
    { name: "autoFillField", types: [EQuestionType.Fill] },
    { name: "required", types: [...this.all.filter(t => t != EQuestionType.Link)] },

    { name: "no-operation" }
  ]
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    if (this.isCollection) {
      const addCollectionEntry = this.dictionary.find(entry => entry.name === "addCollection");
      if (addCollectionEntry) {
        addCollectionEntry.types = []; // Assign the desired types here
      }
    }
    if (this.optionList?.isPublic == true || (this.optionList?.answerOptionItem?.length ?? 0) < 0) {
      const listEntry = this.dictionary.find(entry => entry.name === "saveList");
      if (listEntry) {
        listEntry.types = []; // Assign the desired types here
      }
    }
    const noOperationEntry = this.dictionary.find(entry => entry.name === "no-operation");
    if (noOperationEntry) {
      var typesHaveOperation = [...this.dictionary.flatMap(entry => entry.name === "addCollection" || entry.name === "saveList" ? entry.types : [])];
      noOperationEntry.types = [...this.all.filter(x => {
        return !typesHaveOperation.includes(x);
      })]; // Assign the desired types here
    }
    this.toggleVisibility();
  }
  toggleVisibility() {
    var authorizedTypes = this.dictionary.find(x => x.name === this.name)?.types;
    if (authorizedTypes != null)
      this.isDisplay = authorizedTypes.includes(this.typeId as EQuestionType);
    if (!this.isDisplay) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }

}
